module.exports = __webpack_public_path__ + "img/ditan_xc8.b6227580.jpg";